import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Dashboard, CreateUpdateDashboardModel } from '../../../domain/models/dashboard';
import * as _ from 'lodash';
import { TranslateService } from 'ng2-translate';
import { Language } from '../../../domain/enums/language';
import { DashboardOverviewService } from '../../services/dashboard-overview.service';

@Component({
  selector: 'app-edit-dashboard',
  templateUrl: './edit-dashboard.component.html',
  styleUrls: ['./edit-dashboard.component.scss']
})
export class EditDashboardComponent implements OnInit {
  @Input() public dashboard: Dashboard;
  @Output() public onCreateDashboard: EventEmitter<CreateUpdateDashboardModel>;
  @Output() public onCancel: EventEmitter<void>;
  @ViewChild('logo') logo: any;

  public dashboardEdit: Dashboard;
  public createDashboardForm: FormGroup;
  public readonly minAlternatingInterval = 1;
  public languages = ['NL', 'EN', 'ES', 'FR'];
  public whiteLogoBackground: any;
  public imagePreview: any;
  public logoTooLarge: boolean;

  private updatedDash: CreateUpdateDashboardModel;
  private formLocked: boolean;

  constructor(private dashboardService: DashboardOverviewService) {
    this.onCreateDashboard = new EventEmitter<CreateUpdateDashboardModel>();
    this.onCancel = new EventEmitter<void>();
  }

  ngOnInit() {
    this.formLocked = false;
    this.logoTooLarge = false;
    this.createDashboardForm = this.getFormGroup();
    this.dashboardEdit = _.cloneDeep(this.dashboard);
    this.whiteLogoBackground = this.dashboard.whiteLogoBackground ? 1 : 0;
  }

  formIsInvalid(): boolean {
    return this.createDashboardForm.invalid || this.logoTooLarge;
  }

  updateDashboard(): void {
    if (!this.formLocked) {
      this.formLocked = true;

      this.updatedDash = new CreateUpdateDashboardModel();
      this.updatedDash.id = this.dashboardEdit.id;
      this.updatedDash.name = this.dashboardEdit.name;
      this.updatedDash.url = this.dashboardEdit.url;
      this.updatedDash.language = this.dashboardEdit.language;
      this.updatedDash.alernatingInterval = this.dashboardEdit.alernatingInterval;
      this.updatedDash.fitBoundsToHighlightedRoute = this.dashboardEdit.fitBoundsToHighlightedRoute;
      this.updatedDash.jobs = this.dashboardEdit.jobs;
      this.updatedDash.whiteLogoBackground = this.whiteLogoBackground == 1; // tslint:disable-line:triple-equals
      if (this.logo && this.logo.nativeElement.files && this.logo.nativeElement.files.length > 0) {
        this.handleFiles(this.logo.nativeElement.files[0], true);
      } else {
        this.onCreateDashboard.emit(this.updatedDash);
      }
    }
  }

  clearFilePicker(): void {
    if (this.logo) {
      this.logo.nativeElement.value = '';
    }
    this.imagePreview = undefined;
    this.logoTooLarge = false;
    if (this.updatedDash) {
      this.updatedDash.Base64 = undefined;
    }
  }

  private handleFiles(file: any, submit: boolean): void {
    if (file.size > 209715) {
      this.logoTooLarge = true;
    } else {
      this.logoTooLarge = false;
      let img = document.createElement('img');
      img.classList.add('obj');
      let reader = new FileReader();

      reader.onload = ((aImg) => {
        return (e) => {
          aImg.src = e.target.result;
          this.imagePreview = aImg.src;
          let srcArray = aImg.src.split(',');
          if (this.updatedDash) {
            this.updatedDash.Base64 = srcArray[1];
          }
          if (submit) {
            this.submitDashboard();
          }
        };
      })(img);
      reader.readAsDataURL(file);
    }
  }

  private submitDashboard(): void {
    this.onCreateDashboard.emit(this.updatedDash);
  }

  hasUploadedLogo(): boolean {
    return this.dashboardEdit.logo !== null && this.dashboardEdit.logo !== undefined;
  }
  hasLogo(): boolean {
    return this.imagePreview !== undefined;
  }
  previewLogo(): void {
    this.handleFiles(this.logo.nativeElement.files[0], false);
  }
  getLogo(): string {
    if (this.hasLogo()) {
      return this.imagePreview;
    } else {
      return this.dashboardEdit.logo;
    }
  }
  isWhiteLogoBackground(): boolean {
    return this.whiteLogoBackground == 1; // tslint:disable-line:triple-equals
  }
  deleteLogo(): void {
    this.dashboardService.deleteDashboardLogo(this.dashboard.id)
      .subscribe((result: any) => {
        this.dashboard.logo = undefined;
        this.dashboardEdit.logo = undefined;
        this.clearFilePicker();
      });
  }

  cancel(): void {
    this.onCancel.emit();
  }

  toEnum(lng: string): Language {
    return Language[lng];
  }

  private getFormGroup(): FormGroup {
    return new FormGroup({
      name: new FormControl({ value: this.dashboard.name }, Validators.required),
      alternatingInterval: new FormControl({ value: this.dashboard.alernatingInterval }, [Validators.required, Validators.min(this.minAlternatingInterval)]),
      language: new FormControl({ value: this.dashboard.language }, Validators.required)
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard-overview/components/edit-dashboard/edit-dashboard.component.ts